module.exports = __webpack_public_path__ + "assets/group-specialistams.428c1db2.svg";